function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16 14.586l-2.293-2.293a1 1 0 0 0-1.414 1.414L14.586 16l-2.293 2.293a1 1 0 0 0 1.414 1.414L16 17.414l2.293 2.293a1 1 0 0 0 1.414-1.414L17.414 16l2.293-2.293a1 1 0 0 0-1.414-1.414L16 14.586zM16 24a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
});

var SvgClearSmall = function SvgClearSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#1B1F23",
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "5f9b2627b35db00615305f3dee66cefe.svg";
export { SvgClearSmall as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/clear-small.svg
// module id = null
// module chunks = 